import { getLastPastTenPeriod, getPastTenPeriod,
  getSpecifiedPeriodPrediction } from '@/api/desktop/images'
export default {
  domain: process.env.MARKSIX_SERVER_HOST,
  appName: process.env.APP_NAME,
  imageApi: { getLastPastTenPeriod, getPastTenPeriod,
    getSpecifiedPeriodPrediction }
}
